/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-underscore-dangle */

import blpAuth from '../connection/blp-auth';

interface StoreItem {
	item: string;
	__expiration?: number;
}

export function setStorageItem(key: string, item: string, expirationInHours?: number): void {
	if (typeof item !== 'string') {
		throw new Error('Item in Set Storage must be a string - stringify any objects');
	}
	// Do not set token in local storage in production
	if(key === 'token' && process.env.NODE_ENV !== 'development') {
		return;
	}

	const storeItem: StoreItem = {
		item,
	};

	if (expirationInHours) {
		storeItem.__expiration = Date.now() + (expirationInHours * 60 * 60 * 1000);
	}

	localStorage.setItem(key, JSON.stringify(storeItem));
}

export function setStorageObject(key: string, item: any, expirationInHours?: number) {
	// create structured clone to prevent mutation of the original object
	const storeItem = structuredClone(item);

	if (expirationInHours) {
		storeItem.__expiration = Date.now() + (expirationInHours * 60 * 60 * 1000);
	}

	localStorage.setItem(key, JSON.stringify(storeItem));
}

/**
 *
 * @param {string} key
 */
export function getStorageItem(key: string): any | null {
	if(key === 'token' && process.env.NODE_ENV !== 'development') {
		// In development, we want to be able to see the token in local storage
		// but in production, we don't want to expose it.
		return null;
	}
	const str = localStorage.getItem(key);

	if (str) {
		const item = JSON.parse(str);

		if (!item || (item.__expiration && item.__expiration < Date.now())) {
			removeStorageItem(key);
			return null;
		}
		return item.item;
	}
	return null;
}

export function getStorageObject(key: string): any | null {
	const str = localStorage.getItem(key);

	if (str) {
		const item = JSON.parse(str);

		if (item.__expiration && item.__expiration < Date.now()) {
			removeStorageItem(key);
			return null;
		}
		return item;
	}
	return null;
}

export function removeStorageItem(key: string): void {
	localStorage.removeItem(key);
}

export async function clearStorage(): Promise<void> {
	// Instead of clearing all storage, we manually remove specific items.
	// Some items we want to keep in there
	// like storedTwoFactorEvents & audio/video devices.
	// storedTwoFactorEvents has an expiration date of 30 days
	// so we don't want to mess with it in case the same producer signs back in with Events.
	localStorage.removeItem('token');
	localStorage.removeItem('showrooms-tokens');
	localStorage.removeItem('producer-signed-in');
	localStorage.removeItem('app-signed-in-with');
	localStorage.removeItem('login-activity');
	localStorage.removeItem('stored_vbg');
	// eslint-disable-next-line no-console
	await blpAuth.signOut().catch(console.error);
}
